import { render, staticRenderFns } from "./allOrders.vue?vue&type=template&id=13fd49d7&scoped=true"
import script from "./allOrders.vue?vue&type=script&lang=js"
export * from "./allOrders.vue?vue&type=script&lang=js"
import style0 from "./allOrders.vue?vue&type=style&index=0&id=13fd49d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd49d7",
  null
  
)

export default component.exports